import React from 'react';
import { Box, ThemeProvider, useTheme } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function DateInput({ label, selectedDate, handleDateChange }) {
    const theme = useTheme();

    return (
        <Box width={'100%'}>
            <p
                style={{
                    color: theme.palette.text.primary,
                    fontSize: 13,
                    marginTop: 24,
                    marginBottom: 4,
                }}
            >
                {label}
            </p>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        value={selectedDate}
                        onChange={handleDateChange}
                        format="DD/MM/YYYY HH:mm"
                        ampm={false}
                        sx={{
                            width: '100%',
                            backgroundColor: theme.palette.customGrey.insideInput,
                            '& .MuiInputBase-input': {
                                color: theme.palette.text.primary,
                                '&::placeholder': {
                                    fontSize: '14px',
                                    color: theme.palette.text.secondary,
                                    opacity: 1,
                                },
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: theme.palette.customGrey.borderInput,
                                },
                                '&:hover fieldset': {
                                    borderColor: theme.palette.customGrey.borderInput,
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: theme.palette.primary.main,
                                },
                            },
                        }}
                    />
                </LocalizationProvider>
            </ThemeProvider>
        </Box>
    );
}

export default DateInput;